import { useState } from 'react'
import clsx from 'clsx'
import { Icon } from '@iconify/react'
import extractDomain from 'extract-domain'

import { Button, Collapse, Panel, Tooltip } from '../../../atoms'

import styles from './FAQ.module.css'

interface Props {
  className?: string
  faq: {
    question: string
    answer: string
    link: string
  }
  logoType?: 'img' | 'icon'
  showReadMore?: boolean
  insertHtml?: (text: string) => void
}

const WORD_LIMIT = 80

export function FAQ({
  className,
  faq,
  showReadMore = false,
  insertHtml,
  logoType = 'img'
}: Props) {
  const [isReadMore, setIsReadMore] = useState(showReadMore)

  return (
    <Collapse
      expandIconPosition="right"
      ghost={true}
      expandIcon={({ isActive }) => (
        <Icon
          icon="tabler:chevron-down"
          width={16}
          height={16}
          rotate={isActive ? 90 : 0}
        />
      )}
      className={className}
    >
      <Panel
        key={faq.link}
        className={clsx(styles.accordion, styles.qTab)}
        header={
          <div className={clsx(styles.qHeaderTextWrapper, styles.sHeaderTitle)}>
            <div className={styles.textLogoWrapper}>
              {logoType === 'icon' ? (
                <div className={styles.questionIconWrapper}>
                  <Icon
                    icon="uil:comment-alt-question"
                    width={16}
                    height={16}
                  />
                </div>
              ) : null}
              {logoType === 'img' ? (
                <div className={styles.questionImgWrapper}>
                  <img
                    className={styles.questionImg}
                    alt="Company logo"
                    src={`https://logo.clearbit.com/${extractDomain(faq.link)}`}
                  />
                </div>
              ) : null}

              <div> {faq.question} </div>
            </div>
            {insertHtml ? (
              <div className={styles.insertInDocsBtn}>
                <Tooltip title="Insert In Docs" placement="top">
                  <Button
                    onClick={event => {
                      event.stopPropagation()
                      insertHtml(`<p>${faq.question}</p>`)
                    }}
                    size="small"
                    icon={
                      <Icon icon="uil:file-import" width={16} height={16} />
                    }
                  />
                </Tooltip>
              </div>
            ) : null}
          </div>
        }
      >
        {faq.answer ? (
          <>
            {showReadMore && isReadMore && faq.answer.length > WORD_LIMIT
              ? faq.answer?.slice(0, WORD_LIMIT).concat('...')
              : faq.answer}
            {showReadMore && faq.answer.length > WORD_LIMIT ? (
              <Button onClick={() => setIsReadMore(!isReadMore)} type="link">
                {isReadMore ? 'Read More' : 'Show Less'}
              </Button>
            ) : null}
          </>
        ) : null}
      </Panel>
    </Collapse>
  )
}
